import { render } from "./AposModalShareDraft.vue?vue&type=template&id=050abad8&scoped=true"
import script from "./AposModalShareDraft.vue?vue&type=script&lang=js"
export * from "./AposModalShareDraft.vue?vue&type=script&lang=js"

import "./AposModalShareDraft.vue?vue&type=style&index=0&id=050abad8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050abad8"],['__file',"modal/ui/apos/components/AposModalShareDraft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "050abad8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('050abad8', __exports__)) {
    api.reload('050abad8', __exports__)
  }
  
  module.hot.accept("./AposModalShareDraft.vue?vue&type=template&id=050abad8&scoped=true", () => {
    api.rerender('050abad8', render)
  })

}


export default __exports__